import { Card, Result } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cardmargin, grayheader } from "../CSSReferences";

/**
 * A page that says it is not finished yet.
 *
 * Written on 21.09.2026 for /ScriptUploader, which rendered a completely white
 * page - no menu, no header, nothing. A blank page is the worst answer an
 * application can give, because it does not say whether the feature is broken,
 * empty, still loading or simply not built: the reader is left to guess, and
 * usually guesses that the whole product is broken.
 *
 * Reusable on purpose. Whenever a page has to be taken out of service, route it
 * here with a sentence about why, rather than leaving the route pointing at
 * something that throws.
 */
export interface UnderConstructionProps {
    /** What this page is going to be, in the words the menu uses. */
    title: string;
    /** Why it is not here yet. One or two sentences, plainly put. */
    note?: string;
    /** Where to read more - a finding, an issue, a file. */
    reference?: string;
}

export function UnderConstruction({ title, note, reference }: UnderConstructionProps) {
    return (
        <div>
            <Card title={title} style={cardmargin} hoverable styles={{ header: grayheader }}>
                <Result
                    icon={<FontAwesomeIcon icon={"screwdriver-wrench"} size="3x"
                                           style={{ color: "rgba(149,46,66,1)" }} />}
                    title="Under construction"
                    subTitle={note ?? "This page is being worked on and is not available yet."}
                    extra={reference
                        ? <span style={{ color: "rgba(0,0,0,0.45)" }}>{reference}</span>
                        : undefined}
                />
            </Card>
        </div>
    );
}

export default UnderConstruction;
